import Vue from 'vue'
import VueRouter from 'vue-router'
import First from '../views/First.vue'
import Second from '../views/Second.vue'
import Third from '../views/Third.vue'
import Fourth from '../views/Fourth.vue'
import AdminLogin from '../views/AdminLogin.vue'
import Transactions from '../views/Transactions.vue'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

const routes = [
  {
    path: '/',
    redirect: '/first'
  },
  {
    path: '/first',
    component: First
  },
  {
    path: '/second',
    component: Second
  },
  {
    path: '/third',
    component: Third
  },
  {
    path: '/fourth',
    component: Fourth
  },
  {
    path: '/admin',
    component: AdminLogin
  },
  {
    path: '/transactions',
    component: Transactions
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
